import IconPushClose from '@/components/icons/IconPushClose.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { MEDIA } from '@/helpers/variables';

export default {
  name: 'PushBlock',
  components: { IconPushClose },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      MEDIA
    };
  },
  created() {
    if (this.pushMessage) {
      this.onShow();
    } else {
      this.getPushMessage().then(() => {
        console.log('pushMessage', this.pushMessage);
        if (this.pushMessage) this.onShow();
      });
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      pushMessage: 'pushes/pushMessage',
      isShowPushBlock: 'pushes/isShowPushBlock',
      appSize: 'app/size'
    }),
    displayImageUrl() {
      let { w } = this.appSize;
      let { image, mobileImage } = this.pushMessage;

      if (w > MEDIA.M640 && image) {
        return image;
      }
      if (w <= MEDIA.M640) {
        return mobileImage || image || null;
      }
      return null;
    }
  },
  methods: {
    ...mapActions({
      getPushMessage: 'pushes/GET_PUSH_MESSAGE'
    }),
    ...mapMutations({
      setStatusPushMessage: `pushes/SET_STATUS_PUSH_MESSAGE`
    }),
    onShow() {
      setTimeout(() => {
        console.log('+++++');
        this.setStatusPushMessage(true);

        window.gtag('event', 'sales_popup_view', {
          popup_name: 'outlet_sale'
        });

        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({
        //   event: 'sales_popup_view',
        //   popup_name: 'outlet_sale'
        // });
      }, 5000);
    },
    onClick() {
      window.gtag('event', 'sales_popup_click', {
        popup_name: 'outlet_sale'
      });

      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: 'sales_popup_click',
      //   popup_name: 'outlet_sale'
      // });
      let { link } = this.pushMessage;
      if (link) window.open(link, '_blank');
    },
    onClose() {
      window.gtag('event', 'sales_popup_close', {
        popup_name: 'outlet_sale'
      });

      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: 'sales_popup_close',
      //   popup_name: 'outlet_sale'
      // });

      this.setStatusPushMessage(false);
    }
  },
  beforeUnmount() {}
};
